import React, { FC } from 'react'
import { NavLink, withRouter, match } from 'react-router-dom'

interface NProps {
  toggle: (open: boolean) => void
  open: boolean
  history: any
  location: any
  match: match
  staticContext?: any
}

const Navbar: FC<NProps> = ({ toggle, open, match: { path } }) => {
  return (
    <nav
      className="uk-navbar-container uk-flex-between uk-navbar-transparent nav"
      data-uk-navbar
    >
      <div className="uk-navbar-left">
        <span>
          <a href="/feed" className="logo">
            <i className="material-icons-outlined">album</i>
            <span className="logo-text">Lodies</span>
          </a>
        </span>
      </div>

      <div className="uk-navbar-right uk-visible@s">
        <ul className="uk-navbar-nav">
          <li className={path === `/` ? `uk-active` : undefined}>
            <NavLink to="/feed">Home</NavLink>
          </li>
          <li className={path === `/pricing` ? `uk-active` : undefined}>
            <NavLink to="/pricing">Pricing</NavLink>
            {/* <div className="uk-navbar-dropdown">
                    <ul className="uk-nav uk-navbar-dropdown-nav">
                      <li className="uk-active">
                        <NavLink to="#">Active</NavLink>
                      </li>
                      <li>
                        <NavLink to="#">Item</NavLink>
                      </li>
                      <li>
                        <NavLink to="#">Item</NavLink>
                      </li>
                    </ul>
                  </div> */}
          </li>
          <li className={path === `/` ? `uk-active` : undefined}>
            <NavLink to="/">Features</NavLink>
          </li>
          <li>
            <NavLink to="/login">
              <span
                className="goto-app"
                style={{
                  background: 'rgba(255, 177, 0, 0.19)',
                  borderRadius: '4px',
                }}
              >
                Sign in
              </span>
            </NavLink>
          </li>
        </ul>
      </div>

      <div className="uk-hidden@s uk-navbar-right">
        <span
          className="uk-navbar-nav"
          onClick={() => {
            toggle(!open)
          }}
          style={{ color: `#000` }}
        >
          <i className="material-icons-outlined">{open ? 'close' : 'menu'}</i>
        </span>
      </div>
    </nav>
  )
}

export default withRouter(Navbar)
